export default __webpack_public_path__ + "assets/images/icon-user.813f46d9133fc740d4a5eb003eadd4bf.svg";